import React from "react";
import { TextField, Typography, Flex } from "../../../components";

interface DOBFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const DOBField: React.FC<DOBFieldProps> = ({ value, onChange }) => {
  return (
    <Flex direction="column" gap="xs">
      <Typography variant="caption" colorScheme="muted" as="span">Date of Birth</Typography>
      <TextField
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
      />
    </Flex>
  );
};